import React from 'react';
import { Switch as FormSwitch } from 'antd';
import type { SwitchProps } from 'antd';
import { useToggle } from 'ahooks';

export const Switch: React.FC<SwitchProps> = (props) => {
    const [loading, { toggle }] = useToggle(false);
    const { onChange, onClick, ...restProps } = props
    const handleChange = async (checked: boolean, event: any) => {
        if (loading) return; // 防止重复点击
        try {
            toggle()
            await onChange?.(checked, event)
            await onClick?.(checked, event)
        } finally {
            toggle()
        }
    }
    return <FormSwitch loading={loading} {...restProps} onChange={handleChange}></FormSwitch>
};

